export default "__VITE_ASSET__B45TmyDD__"